import React from 'react';
import { SectionColor } from './Section';
import Tag, { TagProps } from './Tag';

interface TagBarProps {
    backgroundColor: SectionColor;
    tags: TagProps[];
    actions?: JSX.Element;
}

const TagBar = ({ actions, backgroundColor, tags }: TagBarProps) => {
    const getBackgroundClass = () => {
        switch (backgroundColor) {
            case SectionColor.DeepBlue:
                return 'deep-blue';
            case SectionColor.LightSand:
                return 'light-sand';
            case SectionColor.White:
                return 'white';
        }
    };

    return (
        <div className={`tag-bar ${getBackgroundClass()}`}>
            <div className='tags-container'>
                <div className='tags'>
                    {tags.map(x => <Tag key={x.text} {...x} />)}
                </div>
            </div>
            {actions &&
                <div className='tag-bar-actions'>
                    {actions}
                </div>
            }
        </div>
    );
};

export default TagBar;
